import type { RezaOpravneniDto } from '@gov-nx/api/generated/reza.types';
import type { FormatSubjectNameOptions } from '@gov-nx/utils/common/String/personInformation';
import { formatSubjectName } from '@gov-nx/utils/common/String/personInformation';

export interface ZastupujiciOsobaNazevOptions extends Omit<
	FormatSubjectNameOptions,
	'suffix'
> {
	showNazevSablony?: boolean;
}

export const zastupujiciOsobaNazevPO = (
	person: RezaOpravneniDto['zastupujiciOsoba'],
	options?: FormatSubjectNameOptions
) => formatSubjectName(person?.pravnickaOsoba, options);

export const zastupujiciOsobaNazevFO = (
	person: RezaOpravneniDto['zastupujiciOsoba'],
	options?: FormatSubjectNameOptions
) => formatSubjectName(person?.fyzickaOsoba, options);

export const zastupujiciOsobaNazev = (
	{ zastupujiciOsobaTyp, zastupujiciOsoba, nazevSablony }: RezaOpravneniDto,
	{ showNazevSablony, ...options }: ZastupujiciOsobaNazevOptions = {}
) =>
	formatSubjectName(
		zastupujiciOsobaTyp === 'PO'
			? zastupujiciOsoba?.pravnickaOsoba
			: zastupujiciOsoba?.fyzickaOsoba,
		{ ...options, suffix: showNazevSablony ? nazevSablony : undefined }
	);
